<template>
  <wizard-form v-on="$listeners" v-bind="$attrs">
    <template #content>
      <v-row class="mb-5">
        <v-col cols="12">
          <v-alert v-if="showMessages" type="info" elevation="0" class="mb-0">
            <div
              class="font-weight-medium text-body-1 primary--text"
              v-for="message in messages"
              :key="message"
            >
              <span>{{ message }}</span>
            </div>
          </v-alert>
        </v-col>
        <v-col cols="12">
          <span class="font-weight-medium primary--text">Datos de configuración SMTP</span>
          <span class="font-italic ml-3 primary--text">* Campos requeridos</span>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider name="Host" rules="required" v-slot="{ errors }">
            <v-text-field
              label="Host *"
              placeholder="Host"
              v-model="broker.smtp.host"
              dense
              :error-messages="errors[0]"
              append-icon="mdi-server-network"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider
            name="Port"
            rules="required|numeric|min_value:1"
            v-slot="{ errors }"
          >
            <numeric-input
              label="Port *"
              placeholder="Port"
              v-model.number="broker.smtp.port"
              dense
              :error-messages="errors[0]"
              append-icon="mdi-connection"
              :options="{
                maximumValue: 9999999999,
                decimalPlaces: 0,
                digitGroupSeparator: ''
              }"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider
            name="Username"
            rules="required"
            v-slot="{ errors }"
          >
            <v-text-field
              label="Username *"
              placeholder="Username"
              v-model="broker.smtp.username"
              dense
              :error-messages="errors[0]"
              append-icon="mdi-account-box"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider
            name="Password"
            :rules="{
              required: broker.id ? false : true
            }"
            v-slot="{ errors }"
          >
            <v-text-field
              :label="broker.id ? 'Password' : 'Password *'"
              placeholder="Password"
              v-model="broker.smtp.password"
              dense
              :error-messages="errors[0]"
              append-icon="mdi-lock"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6">
          <ValidationProvider
            name="Tipo de encriptación"
            rules="required"
            v-slot="{ errors }"
          >
            <v-select
              :items="items"
              label="Tipo de encriptación *"
              placeholder="Tipo de encriptación"
              v-model="broker.smtp.encryption"
              dense
              :error-messages="errors[0]"
              hide-details
              single-line
              light
            />
          </ValidationProvider>
        </v-col>
      </v-row>
    </template>
  </wizard-form>
</template>

<script>
import WizardForm from '@/components/commons/WizardForm'
import NumericInput from '@/components/commons/NumericInput'
export default {
  components: { WizardForm, NumericInput },
  props: {
    broker: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      items: [
        { text: 'Ninguno', value: null },
        { text: 'SSL', value: 'ssl' },
        { text: 'TLS', value: 'tls' }
      ],
      messages: [
        'Si no desea actualizar el password en la configuración SMTP deje el campo vacío.'
      ]
    }
  },
  computed: {
    showMessages() {
      return this.broker.id
    }
  }
}
</script>
